import getLang from 'I18n/utils/getLang';
import { useState, useCallback } from 'react';
import { LOCALES } from '../../constants/Locales';
import localeContext from '../../context/localeContext';
import { useLocaleQueryParams } from '../../hooks/useLocaleQueryParams';
import { jsx as _jsx } from "react/jsx-runtime";
const safeLocaleChange = possibleLocale => {
  return Object.values(LOCALES).includes(possibleLocale) ? possibleLocale : 'en';
};
export const LocaleProvider = ({
  children
}) => {
  const {
    localeQueryParam,
    updateLocaleQueryParam
  } = useLocaleQueryParams();
  const getInitialLocale = useCallback(() => {
    if (localeQueryParam) {
      return safeLocaleChange(localeQueryParam);
    }
    // Otherwise get current lang from language provider, which should be the users browser locale
    const browserLocale = getLang();
    return safeLocaleChange(browserLocale);
  }, [localeQueryParam]);
  const [locale, setLocale] = useState(getInitialLocale());
  const updateLocale = useCallback(newLocale => {
    setLocale(newLocale);
    updateLocaleQueryParam(newLocale);
  }, [updateLocaleQueryParam]);
  return /*#__PURE__*/_jsx(localeContext.Provider, {
    value: {
      locale,
      updateLocale
    },
    children: children
  });
};